<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-list"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- Card: Tabela de Movimentacoes -->
<div class="table-card">
  <div class="card-header card-header-table">
    <div class="card-header-left">
      <div class="card-header-icon table-icon">
        <i class="pi pi-list"></i>
      </div>
      <span class="card-header-title">{{ texts.movimentacoes }}</span>
    </div>
    <div class="card-header-filters">
      <!-- Filtro Conta (inline no header) -->
      <div class="header-filter-field">
        <p-dropdown [options]="contas" optionLabel="label" optionValue="value"
          [(ngModel)]="contaSelecionada" [showClear]="false" [filter]="true"
          [loading]="loadingContas" (onChange)="onContaChange()"
          [placeholder]="texts.conta" appendTo="body"
          [style]="{ width: '100%' }">
          <ng-template pTemplate="selectedItem" let-conta>
            <div class="dropdown-conta-item" *ngIf="conta">
              <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
              <span>{{ conta.label }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="item" let-conta>
            <div class="dropdown-conta-item">
              <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
              <span>{{ conta.label }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <!-- Filtro Periodo (inline no header) -->
      <div class="header-filter-field">
        <app-periodo-filtro
          modo="avancado"
          [valorPadrao]="'today'"
          [textoExibicao]="periodoSelecionado.texto"
          styleClass="w-full"
          (periodoChanged)="onPeriodoDespesaChanged($event)">
        </app-periodo-filtro>
      </div>
    </div>
    <!-- Seletor de colunas + Botao filtros avancados + Exportar -->
    <div class="card-header-actions">
      <app-column-selector
        [columns]="tableColumns"
        [storageKey]="STORAGE_KEY"
        (columnsChange)="onColumnsChange($event)">
      </app-column-selector>
      <button pButton icon="pi pi-sliders-h"
        class="p-button-sm header-filter-btn"
        [pTooltip]="texts.filtros_avancados" tooltipPosition="top"
        (click)="sidebarFiltrosVisible = true">
      </button>
      <!-- Botao Exportar Relatorio (PDF do extrato de caixa com os filtros atuais) -->
      <button pButton icon="pi pi-file-pdf"
        class="p-button-sm header-filter-btn header-export-btn"
        [pTooltip]="'movimentacao.tooltips.exportar_relatorio' | translate" tooltipPosition="top"
        [disabled]="!contaSelecionada || exportandoPdf"
        [loading]="exportandoPdf"
        (click)="exportarPdf()">
        <span class="header-export-label">{{ 'movimentacao.botoes.exportar_relatorio' | translate }}</span>
      </button>
    </div>
  </div>
  <div class="card-content">

    <!-- Cards de Totais por Moeda (clicaveis apenas quando EFETIVO esta selecionado) -->
    <div class="totais-moeda-section">
      <div class="totais-moeda-cards">
        <div class="total-moeda-card total-guarani"
          *ngIf="moedasPermitidas.has('GUARANI') && (!contaBancariaAtiva || moedaContaSelecionada === 'GUARANI')"
          [class.total-moeda-card--active]="filtroMoedaSelecionada === 'GUARANI'"
          (click)="filtrarPorMoeda('GUARANI')">
          <div class="total-moeda-icon">
            <img src="assets/images/paraguay-flag.jpg" class="flag-icon-small" alt="" />
          </div>
          <div class="total-moeda-info">
            <span class="total-moeda-label">{{ texts.total_guarani }}</span>
            <span class="total-moeda-valor" [class.text-red-500]="totalGuarani < 0">
              Gs {{ totalGuarani | number:'1.0-0':'es-PY' }}
            </span>
          </div>
          <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'GUARANI'"></i>
        </div>
        <div class="total-moeda-card total-dolar"
          *ngIf="moedasPermitidas.has('DOLAR') && (!contaBancariaAtiva || moedaContaSelecionada === 'DOLAR')"
          [class.total-moeda-card--active]="filtroMoedaSelecionada === 'DOLAR'"
          (click)="filtrarPorMoeda('DOLAR')">
          <div class="total-moeda-icon">
            <img src="assets/images/usa-flag.svg" class="flag-icon-small" alt="" />
          </div>
          <div class="total-moeda-info">
            <span class="total-moeda-label">{{ texts.total_dolar }}</span>
            <span class="total-moeda-valor" [class.text-red-500]="totalDolar < 0">
              $ {{ totalDolar | number:'1.2-2':'en-US' }}
            </span>
          </div>
          <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'DOLAR'"></i>
        </div>
        <div class="total-moeda-card total-real"
          *ngIf="moedasPermitidas.has('REAL') && (!contaBancariaAtiva || moedaContaSelecionada === 'REAL')"
          [class.total-moeda-card--active]="filtroMoedaSelecionada === 'REAL'"
          (click)="filtrarPorMoeda('REAL')">
          <div class="total-moeda-icon">
            <img src="assets/images/br-flag.svg" class="flag-icon-small" alt="" />
          </div>
          <div class="total-moeda-info">
            <span class="total-moeda-label">{{ texts.total_real }}</span>
            <span class="total-moeda-valor" [class.text-red-500]="totalReal < 0">
              R$ {{ totalReal | number:'1.2-2':'pt-BR' }}
            </span>
          </div>
          <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'REAL'"></i>
        </div>
        <div class="total-moeda-card total-peso"
          *ngIf="moedasPermitidas.has('PESO') && (!contaBancariaAtiva || moedaContaSelecionada === 'PESO')"
          [class.total-moeda-card--active]="filtroMoedaSelecionada === 'PESO'"
          (click)="filtrarPorMoeda('PESO')">
          <div class="total-moeda-icon">
            <img src="assets/images/argentina-flag.svg" class="flag-icon-small" alt="" />
          </div>
          <div class="total-moeda-info">
            <span class="total-moeda-label">{{ texts.total_peso }}</span>
            <span class="total-moeda-valor" [class.text-red-500]="totalPeso < 0">
              $ {{ totalPeso | number:'1.2-2':'es-AR' }}
            </span>
          </div>
          <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'PESO'"></i>
        </div>
      </div>
      <!-- Indicador de filtros client-side ativos (tipo despesa / tipo receita) -->
      <div class="filtro-moeda-ativo" *ngIf="filtroTipoDespesa || filtroTipoReceita">
        <i class="pi pi-filter"></i>
        <span>{{ 'movimentacao.filtros.filtros_ativos' | translate }}:
          <strong *ngIf="filtroTipoDespesa">{{ 'movimentacao.labels.filtro_tipo_despesa' | translate }}</strong>
          <strong *ngIf="filtroTipoDespesa && filtroTipoReceita">, </strong>
          <strong *ngIf="filtroTipoReceita">{{ 'movimentacao.labels.filtro_tipo_receita' | translate }}</strong>
        </span>
        <button class="filtro-moeda-limpar" (click)="limparFiltrosAvancados()">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <!-- Tabela -->
    <p-table [value]="baixas" [loading]="loading"
      [scrollable]="true" scrollHeight="60vh"
      [tableStyle]="{ 'min-width': '50rem', 'margin-top': '16px' }" dataKey="id"
      sortMode="single"
      [defaultSortOrder]="1"
      [customSort]="true"
      (sortFunction)="customSort($event)">

      <ng-template pTemplate="header">
        <tr>
          <th [hidden]="!isColumnVisible('emissao')"
              pSortableColumn="emissao" style="width: 9%">
            {{ labels.data_emissao }}
            <p-sortIcon field="emissao"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('codigoBaixa')"
              pSortableColumn="codigoBaixa" style="width: 5%">
            {{ labels.codigo }}
            <p-sortIcon field="codigoBaixa"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('descricao')"
              pSortableColumn="descricao" style="width: 16%">
            {{ labels.descricao }}
            <p-sortIcon field="descricao"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('informacao')" style="width: 8%">
            {{ labels.informacao }}
          </th>
          <th [hidden]="!isColumnVisible('pessoa')"
              pSortableColumn="pessoa.nome" style="width: 9%">
            {{ labels.pessoa }}
            <p-sortIcon field="pessoa.nome"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('tipoTransacao')"
              pSortableColumn="tipoDeTransacao" style="width: 10%">
            {{ labels.tipo_transacao }}
            <p-sortIcon field="tipoDeTransacao"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('entrada')"
              pSortableColumn="valor" style="width: 12%" class="text-right">
            {{ labels.entrada }}
            <p-sortIcon field="valor"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('saida')"
              style="width: 12%" class="text-right">
            {{ labels.saida }}
          </th>
          <th [hidden]="!isColumnVisible('acoes')" style="width: 5%" class="text-center">
            {{ labels.acoes }}
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-baixa>
        <tr>
          <td [hidden]="!isColumnVisible('emissao')">
            {{ baixa.emissao | date: 'dd/MM/yyyy HH:mm' }}
          </td>
          <td [hidden]="!isColumnVisible('codigoBaixa')">{{ baixa.codigoBaixa }}</td>
          <td [hidden]="!isColumnVisible('descricao')">{{ baixa.descricao || '-' }}</td>
          <td [hidden]="!isColumnVisible('informacao')">{{ baixa.informacaoDaTransacao || '-' }}</td>
          <td [hidden]="!isColumnVisible('pessoa')">
            <span *ngIf="baixa.pessoa; else semPessoa">
              {{ baixa.pessoa.nome || baixa.pessoa.fantasia || '-' }}
            </span>
            <ng-template #semPessoa>-</ng-template>
          </td>
          <td [hidden]="!isColumnVisible('tipoTransacao')">
            <div class="tipo-transacao-stacked">
              <span [class]="getOperacaoColor(baixa)">
                {{ getTipoTransacaoDescricao(baixa) }}
              </span>
              <span *ngIf="getSubtipoLabel(baixa) as subtipo"
                    class="tipo-subtipo"
                    [pTooltip]="subtipo"
                    tooltipPosition="top">
                <span *ngIf="getSubtipoCor(baixa) as cor"
                      class="subtipo-dot"
                      [style.background-color]="cor"></span>
                {{ subtipo }}
              </span>
            </div>
          </td>
          <td [hidden]="!isColumnVisible('entrada')" class="text-right">
            <span *ngIf="getEntradaValue(baixa)" class="text-green-600 font-bold">
              {{ formatarValorMonetario(getEntradaValue(baixa), baixa.moeda) }}
            </span>
            <span *ngIf="!getEntradaValue(baixa)" class="text-gray-400">-</span>
          </td>
          <td [hidden]="!isColumnVisible('saida')" class="text-right">
            <span *ngIf="getSaidaValue(baixa)" class="text-red-600 font-bold">
              {{ formatarValorMonetario(getSaidaValue(baixa), baixa.moeda) }}
            </span>
            <span *ngIf="!getSaidaValue(baixa)" class="text-gray-400">-</span>
          </td>
          <td [hidden]="!isColumnVisible('acoes')" class="text-center">
            <button pButton type="button"
              [icon]="getIconeEditar(baixa)"
              class="p-button-sm p-button-text p-button-rounded"
              [pTooltip]="getTooltipEditar(baixa)" tooltipPosition="top"
              [disabled]="!podeEditar(baixa)"
              (click)="editarBaixa(baixa)">
            </button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
            <div class="flex flex-column align-items-center">
              <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
              <div class="text-gray-500 text-lg">{{ texts.nenhuma_movimentacao }}</div>
              <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr>
          <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
            <div class="flex justify-content-center align-items-center">
              <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
              <span class="ml-3">{{ texts.carregando }}</span>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        <tr *ngIf="baixas.length > 0">
          <td [attr.colspan]="footerLabelColspan" class="text-right font-bold text-700 pr-4">
            {{ texts.totais_do_periodo }}
          </td>
          <td [hidden]="!isColumnVisible('entrada')" class="text-right">
            <span class="text-green-600 font-bold" style="font-size: 1.05rem;">
              {{ formatarValorView(totalEntradasPeriodo) }}
            </span>
          </td>
          <td [hidden]="!isColumnVisible('saida')" class="text-right">
            <span class="text-red-600 font-bold" style="font-size: 1.05rem;">
              {{ formatarValorView(totalSaidasPeriodo) }}
            </span>
          </td>
          <td [hidden]="!isColumnVisible('acoes')"></td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- Sidebar de Filtros Avancados -->
<p-sidebar [(visible)]="sidebarFiltrosVisible" position="right" [style]="{ width: '28rem' }" [blockScroll]="true"
    styleClass="shadow-lg">
    <ng-template pTemplate="header">
        <div class="sidebar-wave-header sidebar-wave-header--info">
            <div class="sidebar-wave-header-content">
                <div class="sidebar-wave-icon-container">
                    <i class="pi pi-sliders-h" aria-hidden="true"></i>
                </div>
                <div class="sidebar-wave-header-text">
                    <h2>{{ texts.filtros_avancados }}</h2>
                    <p>{{ texts.filtros_avancados_subtitulo }}</p>
                </div>
            </div>
            <div class="sidebar-wave-decorative-circle circle-1" aria-hidden="true"></div>
            <div class="sidebar-wave-decorative-circle circle-2" aria-hidden="true"></div>
            <svg class="sidebar-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
                <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
            </svg>
        </div>
    </ng-template>

    <div class="sidebar-filtros-body">
        <!-- Filtro Descricao -->
        <div class="sidebar-filtro-field">
            <label class="form-label">{{ labels.descricao }}</label>
            <input type="text" pInputText [(ngModel)]="filtroDescricao"
                [placeholder]="placeholders.pesquisar" class="w-full" />
        </div>

        <!-- Filtro Tipo Transacao -->
        <div class="sidebar-filtro-field">
            <label class="form-label">{{ labels.tipo_transacao }}</label>
            <p-dropdown [options]="tipoTransacaoOptions" [(ngModel)]="filtroTipoTransacao"
                optionLabel="label" optionValue="value"
                [placeholder]="placeholders.selecionar" [showClear]="true" appendTo="body"
                panelStyleClass="filtros-movimentos-dropdown-panel dropdown-panel-above-modal"
                [style]="{ width: '100%' }">
            </p-dropdown>
        </div>

        <!-- Filtro Pessoa (cliente/fornecedor) -->
        <div class="sidebar-filtro-field">
            <label class="form-label">{{ labels.pessoa }}</label>
            <app-entity-selector
                [config]="filtroPessoaSelectorConfig"
                [(value)]="filtroPessoaSelecionada"
                panelStyleClass="dropdown-panel-above-modal"
                (entitySelected)="onFiltroPessoaSelecionada($event)"
                (valueChange)="$event === undefined && onFiltroPessoaLimpa()"
                (addNew)="abrirDialogoPessoa()">
            </app-entity-selector>
        </div>

        <!-- Filtro Tipo de Gasto -->
        <div class="sidebar-filtro-field">
            <label class="form-label">{{ labels.filtro_tipo_despesa }}</label>
            <p-dropdown [options]="tiposDespesaFiltro" [(ngModel)]="filtroTipoDespesa"
                optionLabel="label" optionValue="value"
                [placeholder]="placeholders.selecionar" [filter]="true"
                filterBy="label" [showClear]="true" appendTo="body"
                panelStyleClass="filtros-movimentos-dropdown-panel dropdown-panel-above-modal"
                [style]="{ width: '100%' }">
                <ng-template let-item pTemplate="item">
                    <div class="flex align-items-center gap-2">
                        <div *ngIf="item.icone || item.cor" class="flex align-items-center justify-content-center border-circle"
                            [ngStyle]="{ width: '28px', height: '28px', 'min-width': '28px', background: item.cor || '#eceff4' }">
                            <i class="{{ item.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.75rem;"></i>
                        </div>
                        <span>{{ item.label }}</span>
                    </div>
                </ng-template>
                <ng-template let-item pTemplate="selectedItem">
                    <div class="flex align-items-center gap-2" *ngIf="item">
                        <div *ngIf="item.icone || item.cor" class="flex align-items-center justify-content-center border-circle"
                            [ngStyle]="{ width: '22px', height: '22px', 'min-width': '22px', background: item.cor || '#eceff4' }">
                            <i class="{{ item.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.6rem;"></i>
                        </div>
                        <span>{{ item.label }}</span>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>

        <!-- Filtro Tipo de Ingresso -->
        <div class="sidebar-filtro-field">
            <label class="form-label">{{ labels.filtro_tipo_receita }}</label>
            <p-dropdown [options]="tiposReceitaFiltro" [(ngModel)]="filtroTipoReceita"
                optionLabel="label" optionValue="value"
                [placeholder]="placeholders.selecionar" [filter]="true"
                filterBy="label" [showClear]="true" appendTo="body"
                panelStyleClass="filtros-movimentos-dropdown-panel dropdown-panel-above-modal"
                [style]="{ width: '100%' }">
                <ng-template let-item pTemplate="item">
                    <div class="flex align-items-center gap-2">
                        <div *ngIf="item.icone || item.cor" class="flex align-items-center justify-content-center border-circle"
                            [ngStyle]="{ width: '28px', height: '28px', 'min-width': '28px', background: item.cor || '#eceff4' }">
                            <i class="{{ item.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.75rem;"></i>
                        </div>
                        <span>{{ item.label }}</span>
                    </div>
                </ng-template>
                <ng-template let-item pTemplate="selectedItem">
                    <div class="flex align-items-center gap-2" *ngIf="item">
                        <div *ngIf="item.icone || item.cor" class="flex align-items-center justify-content-center border-circle"
                            [ngStyle]="{ width: '22px', height: '22px', 'min-width': '22px', background: item.cor || '#eceff4' }">
                            <i class="{{ item.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.6rem;"></i>
                        </div>
                        <span>{{ item.label }}</span>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>

    <!-- Footer do sidebar com botoes -->
    <div class="sidebar-filtros-footer">
        <button pButton [label]="botoes.limpar_filtros"
            icon="pi pi-times" class="p-button-sm p-button-secondary"
            (click)="limparFiltrosAvancados(); sidebarFiltrosVisible = false">
        </button>
        <button pButton [label]="botoes.filtrar"
            icon="pi pi-search" class="p-button-sm btn-primary"
            (click)="aplicarFiltrosAvancados(); sidebarFiltrosVisible = false">
        </button>
    </div>
</p-sidebar>

<!-- Dialog Adicionar Pessoa (acessivel a partir do filtro de Persona) -->
<app-pessoa-adicionar-dialog
  [(visible)]="visibleDialogPessoa"
  tipo="cliente"
  (pessoaCriada)="onPessoaCriadaNoDialog($event)"
  (pessoaVinculada)="onPessoaCriadaNoDialog($event)">
</app-pessoa-adicionar-dialog>
